module.exports = __webpack_public_path__ + "static/img/qualifications_icon_07.851615f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/qualifications_icon_07.png
// module id = beKp
// module chunks = 3